<!--
 * @Author: zyf
 * @Date: 2025-03-18 13:58:55
 * @LastEditors: zyf
 * @LastEditTime: 2025-03-18 15:51:33
 * @Descripttion: 
-->
<template>
  <el-form
    ref="formRef"
    class="save-form"
    :model="formData"
    :rules="rules"
  >
    <el-form-item label="草稿名称" prop="name">
      <el-input v-model="formData.name" placeholder="请输入草稿名称" @change="onChange"></el-input>
    </el-form-item>
    <el-form-item label="模板描述" prop="desc">
      <el-radio-group v-model="formData.type" @change="onChange">
        <el-radio :label="1">个人资源</el-radio>
        <el-radio :label="2">公共资源</el-radio>
      </el-radio-group>
    </el-form-item>
  </el-form>
</template>

<script>
import { Input,RadioGroup,Radio } from 'element-ui';

export default {
  name: 'SaveCache',
  components: {
    'el-input': Input,
    'el-radio-group': RadioGroup,
    'el-radio': Radio,
  },
  props: {
    formCache: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      rules: {
        name: [
          { required: true, message: '请输入草稿名称', trigger: 'blur' },
        ]
      },
      formData: this.formCache
    }
  },
  watch: {
    formCache: {
      handler(newVal) {
        this.formData = newVal;
      },
      deep: true
    }
	},
  created() {

  },
  methods: {
    formValidate() {
      return new Promise((resolve, reject) => {
        const form = this.$refs.formRef;
        if (!form) return reject(new Error('Form reference is missing'));

        form.validate()
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    onChange(){
      this.$emit('change', this.formData);
    }
  }
}
</script>

<style lang="less" scoped>
.save-form {
  padding-top: 16px;
}
</style>